/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface PerturbedDatasetPolymorphicPerturbedTextGenerationDataset
 */
export interface PerturbedDatasetPolymorphicPerturbedTextGenerationDataset {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof PerturbedDatasetPolymorphicPerturbedTextGenerationDataset
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof PerturbedDatasetPolymorphicPerturbedTextGenerationDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PerturbedDatasetPolymorphicPerturbedTextGenerationDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedDatasetPolymorphicPerturbedTextGenerationDataset
   */
  hasPredictions?: boolean;
  /**
   *
   * @type {number}
   * @memberof PerturbedDatasetPolymorphicPerturbedTextGenerationDataset
   */
  originalDataset: number;
  /**
   *
   * @type {Perturbation}
   * @memberof PerturbedDatasetPolymorphicPerturbedTextGenerationDataset
   */
  readonly perturbation: Perturbation;
  /**
   *
   * @type {Array<number>}
   * @memberof PerturbedDatasetPolymorphicPerturbedTextGenerationDataset
   */
  documents?: Array<number>;
}

/**
 * Check if a given object implements the PerturbedDatasetPolymorphicPerturbedTextGenerationDataset interface.
 */
export function instanceOfPerturbedDatasetPolymorphicPerturbedTextGenerationDataset(
  value: object,
): value is PerturbedDatasetPolymorphicPerturbedTextGenerationDataset {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('originalDataset' in value) || value['originalDataset'] === undefined) return false;
  if (!('perturbation' in value) || value['perturbation'] === undefined) return false;
  return true;
}

export function PerturbedDatasetPolymorphicPerturbedTextGenerationDatasetFromJSON(
  json: any,
): PerturbedDatasetPolymorphicPerturbedTextGenerationDataset {
  return PerturbedDatasetPolymorphicPerturbedTextGenerationDatasetFromJSONTyped(json, false);
}

export function PerturbedDatasetPolymorphicPerturbedTextGenerationDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerturbedDatasetPolymorphicPerturbedTextGenerationDataset {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'] == null ? undefined : json['has_predictions'],
    originalDataset: json['original_dataset'],
    perturbation: PerturbationFromJSON(json['perturbation']),
    documents: json['documents'] == null ? undefined : json['documents'],
  };
}

export function PerturbedDatasetPolymorphicPerturbedTextGenerationDatasetToJSON(
  value?: Omit<PerturbedDatasetPolymorphicPerturbedTextGenerationDataset, 'id' | 'perturbation'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    dataset_path: value['datasetPath'],
    has_predictions: value['hasPredictions'],
    original_dataset: value['originalDataset'],
    documents: value['documents'],
  };
}
